import { TALK_TO_US } from './tabsLinksData';

export const defaultTabs = [
  {
    href: (language = 'en') => TALK_TO_US[language.toUpperCase()],
    'data-event': 'support-click',
    key: 'header:Contact us',
    target: '_blank'
  },
  {
    href: () => process.env.SELF_SERVICE_URL,
    'data-event': 'self-service-click',
    key: 'header:List your property',
    styleName: 'list-your-place',
    target: '_blank'
  }
];
